// Wrappers around adexp objects contained in adexpjson.go

const LONG_MESSAGE_THRESHOLD = 1024;
const TRUNCATED_MESSAGE_HEAD_LENGTH = 42;
const TRUNCATED_MESSAGE_TAIL_LENGTH = 42;

export class AdexpMetricV2 {
  constructor(name, value) {
    this.name = name;
    this.value = value;
  }
}

export class AdexpJavaScriptError {
  constructor({
    message,
    severity = "error",
    sourceURL,
    line,
    column,
    stack,
  } = {}) {
    this.error = {
      message: truncateMessage(message),
      severity,
      sourceURL,
      line,
      column,
      stack,
    };
  }
}

export class AdexpLog {
  constructor(tag, message, data) {
    this.tag = tag;
    this.message = truncateMessage(message);
    Object.assign(this, data);
  }
}

export class AdexpContext {
  constructor({ viewportWidth, viewportHeight, adLanguage, mraid } = {}) {
    this.ad_language = adLanguage;
    this.mraid = mraid;
    this.viewport_height = viewportHeight;
    this.viewport_width = viewportWidth;
  }
}

export class AdexpMessage {
  constructor({ context, metric, log } = {}) {
    Object.assign(this, context);
    // NOTE(Austin): metrics_v2 must be an array. For now
    // we don't log more than one metric at a time though.
    this.metrics_v2 = metric != null ? [metric] : undefined;
    this.log = log;
  }
}

// TODO(Austin): Consolidate ClickMetric here.

/**
 * Returns a function that takes a snapshot of the current environment
 * and returns a `AdexpContext`.
 */
export const getAdexpContextSnapshotFn = (viewportEl, hasMraidFn) => () => {
  const { width, height } =
    viewportEl != null ? viewportEl.getBoundingClientRect() : {};
  return new AdexpContext({
    viewportWidth: width != null ? Math.round(width) : undefined,
    viewportHeight: height != null ? Math.round(height) : undefined,
    adLanguage: navigator.language,
    mraid: hasMraidFn(),
  });
};

export const truncateMessage = (message) => {
  if (typeof message !== "string") return "";
  if (message.length >= LONG_MESSAGE_THRESHOLD) {
    return `${message.slice(0, TRUNCATED_MESSAGE_HEAD_LENGTH)}...${message.slice(-TRUNCATED_MESSAGE_TAIL_LENGTH)}`;
  }
  return message;
};



// WEBPACK FOOTER //
// ./src/js/madlib/adexp.js